module.exports = __webpack_public_path__ + "img/cloud-bg.e7098875.webp";